module.exports = __webpack_public_path__ + "img/Grou2p.0dccafe4.png";